export function calcColorDiffTexto(backgroundColor: any) {
    const hexColor = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(backgroundColor);
    if (!hexColor) {
      return null;
    }

    const rgbColor = {
      r: parseInt(hexColor[1], 16) * 0.2126,
      g: parseInt(hexColor[2], 16) * 0.7152,
      b: parseInt(hexColor[3], 16) * 0.0722,
    };

    const perceivedLightness = (rgbColor.r + rgbColor.g + rgbColor.b) / 255;
    const threshold = 0.5;
    return `hsl(0, 0%, ${perceivedLightness - threshold} * -10000000%) `;
}